// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

import {Component, OnInit} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'meta-comp',
    styles: [require('../styles/common/global.scss')],
    encapsulation: ViewEncapsulation.None,
    template: ``,
})
export class MetaComponent implements OnInit {
  constructor(private meta:Meta,
              private title:Title) {}

  ngOnInit() {
      // this.meta.addTag({name: "twitter:title", content: 'Crowdspire'});
      // this.meta.addTag({property: "og:title", content: 'Crowdspire'});
      // this.meta.addTag({name: "description", content: 'Crowdspire is a crowdfunding platform that minimizes fees, so more money goes toward the causes you really care about.'});
      // this.meta.addTag({property: "og:description", content: 'Crowdspire is a crowdfunding platform that minimizes fees, so more money goes toward the causes you really care about.'});
      // this.meta.addTag({name: "twitter:image", content: 'https://crowdspire.org/static/img/share-image.jpg'});
      // this.meta.addTag({property: "og:image", content: 'https://crowdspire.org/static/img/share-image.jpg'});
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/components/meta.component.ts